module.exports = __webpack_public_path__ + "img/step2-en.e0403576.png";